import(/* webpackMode: "eager" */ "/app/app/admin/login/page.tsx");
